module.exports = __webpack_public_path__ + "img/ic_activity_cmt_in.c5ba7c07.svg";